import { EWalletId } from "modules/api/const";
import { getWalletName } from "./getWalletName";

export const getIsMetamaskWallet = (wallet: string): boolean => {
  return getWalletName(EWalletId.metamask) === wallet;
};
